import React from "react";
import { useNavigate } from "react-router-dom";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Variable, Image as ImageIcon, Plus } from "lucide-react";
import { TEMPLATES } from "@/constants/testIds";

export function VariablePanel({ variables, images, onInsertVariable, onOpenImagePicker, onQuickInsertImage }) {
  const navigate = useNavigate();
  return (
    <>
      <Card className="p-5 border-slate-200 shadow-sm">
        <div className="flex items-center gap-2 mb-3">
          <Variable className="w-4 h-4 text-orange-600" strokeWidth={1.75} />
          <h3 className="text-sm font-semibold text-slate-900">Variables disponibles</h3>
        </div>
        <div className="flex flex-wrap gap-1.5" data-testid={TEMPLATES.variablesList}>
          {variables.map((v) => (
            <button key={v.key} type="button" onClick={() => onInsertVariable(v.key)}
              className="text-[11px] px-2 py-1 rounded border border-slate-200 bg-white hover:bg-orange-50 hover:border-orange-300 hover:text-orange-700 transition-colors font-mono"
              data-testid={`var-${v.key}`}>
              {"{" + v.key + "}"}
            </button>
          ))}
        </div>
      </Card>

      <Card className="p-5 border-slate-200 shadow-sm">
        <div className="flex items-center justify-between mb-3">
          <div className="flex items-center gap-2">
            <ImageIcon className="w-4 h-4 text-orange-600" strokeWidth={1.75} />
            <h3 className="text-sm font-semibold text-slate-900">Recursos gráficos</h3>
          </div>
          <Button size="sm" variant="outline" onClick={onOpenImagePicker}
            className="border-slate-200 hover:bg-orange-50 hover:text-orange-700 hover:border-orange-200 h-7 text-xs"
            data-testid="open-image-picker-btn">
            <Plus className="w-3.5 h-3.5 mr-1" strokeWidth={1.75} /> Insertar imagen
          </Button>
        </div>
        {images.length === 0 ? (
          <div className="text-xs text-slate-400 py-4 text-center border border-dashed border-slate-200 rounded">
            No hay imágenes en el repositorio.
            <Button variant="link" size="sm" onClick={() => navigate("/images")}
              className="text-orange-600 hover:text-orange-700 h-auto p-0 ml-1 text-xs">
              Añadir imágenes →
            </Button>
          </div>
        ) : (
          <div className="grid grid-cols-4 gap-2" data-testid="quick-images-grid">
            {images.slice(0, 8).map((img) => (
              <button key={img.id} type="button" onClick={() => onQuickInsertImage(img)}
                title={`Insertar: ${img.name}`}
                className="group relative aspect-square rounded border border-slate-200 bg-slate-50 overflow-hidden hover:border-orange-400 hover:ring-2 hover:ring-orange-100 transition-all"
                data-testid={`quick-image-${img.id}`}>
                <img src={img.url} alt={img.alt_text || img.name}
                  className="w-full h-full object-contain p-1" referrerPolicy="no-referrer" />
                <span className="absolute inset-x-0 bottom-0 bg-slate-900/80 text-white text-[9px] font-medium px-1 py-0.5 opacity-0 group-hover:opacity-100 transition-opacity truncate">
                  {img.name}
                </span>
              </button>
            ))}
          </div>
        )}
        {images.length > 8 && (
          <div className="text-[11px] text-slate-500 mt-2 text-center">
            {images.length - 8} imagen(es) más en el repositorio.
            <button type="button" onClick={onOpenImagePicker}
              className="text-orange-600 hover:text-orange-700 font-medium ml-1">
              Ver todas →
            </button>
          </div>
        )}
      </Card>
    </>
  );
}
